import React, { Component } from 'react';
import _ from 'lodash';
import ReactPlayer from 'react-player';

class ReactPlayerWrapper extends Component {

    constructor(props){
        super(props);
        this.state={

        }
        this._videoRef = null;
        this._durationTimeout = null;
        this._recursiveDelay = 0;
    }

    componentDidMount(){
        //console.log("react player wrapper mounted");
        // console.log(this.props.slide);
        this.wait();
    }

    componentWillUnmount() {
        //console.log("react player unmounted");
        clearTimeout(this._durationTimeout);
        this._durationTimeout = null;
    }

    wait = () => {
        clearTimeout(this._durationTimeout);
		this._durationTimeout = setTimeout(() => {
            let duration = null;
            if (this._videoRef) {
                duration = this._videoRef.getDuration();
            }
            if (!duration){
                // console.log("no duration")
                this._recursiveDelay += 0.01;
                this.wait();
            }
            else{
                this.props.handleVideoDuration(duration, this._recursiveDelay);
            }
		}, 10);
    }   

    render(){
        return(
            <ReactPlayer 
            ref={el => this._videoRef = el} 
            volume={this.props.volume} 
            // onEnded={this.props.onEnded} 
            url={this.props.url} 
            width={this.props.width} 
            height={this.props.height} 
            playing={this.props.playing} loop={false} />
        )
    }

}

export default ReactPlayerWrapper


// WEBPACK FOOTER //
// ./src/Components/Slideshow/ReactPlayerWrapper.js